import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_benndorf.png",
      alt: "Estratégias Benndorf",
    },
    title: "Estratégias automatizadas da melhor casa de análises do país.",

    // String ou array de strings
    text: "Os analistas da Benndorf Research possuem anos de experiência em bolsa e resultados impressionantes em operações com minicontratos. Com essa extensão, você terá acesso a estratégias robustas para alavancar suas chances de sucesso em WIN e WDO!",
    // testimonial: {
    //   text: "",
    //   author: {
    //     name: "",
    //     picture: "",
    //   },
    // },
  },
  stats: {
    title: "Alguns números da Benndorf",
    subtitle:
      "Da educação financeira à agilidade nas operações, o objetivo da casa de análises é auxiliar todo tipo de trader a operar mais e melhor.",
    data: [
      {
        value: "+7 anos",
        description: "Ajudando investidores e traders a alcançarem resultados.",
      },
      {
        value: "+700%",
        description:
          "De retornos desde 2011 com seu principal produto, a Absolute 30.",
      },
      {
        value: "+2 anos",
        description:
          "Fechando todos os meses (2020 até Jul/2022) no positivo em dólar e índice, com as operações do analista João Tonello.",
      },
    ],
  },
  features: {
    title: "Por que utilizar os robôs da Benndorf?",
    subtitle: "Veja quais as principais vantagens dos robôs da Benndorf.",
    data: [
      {
        icon: iconsSet.favorite,
        title: "Sem barreira emocional",
        description:
          "Utilizando estratégias automatizadas, você deixa de tomar decisões irracionais e de maneira impulsiva.",
      },
      {
        icon: iconsSet.clock,
        title: "Mais tempo para você",
        description:
          "Enquanto o robô opera, você dedica seu tempo a outras atividades e não precisa ficar acompanhando o mercado.",
      },
      {
        icon: iconsSet.lightning,
        title: "Mais velocidade",
        description:
          "Os algoritmos permitem que o robô tome decisões mais rápidas do que um ser humano, auxiliando na performance das operações.",
      },
      // ...defaultContent.features.data,
    ],
  },
  cta: {
    title: "Pronto para iniciar?",
    subtitle: "Ative agora mesmo a extensão Benndorf.",
  },
  about: {
    title: "Sobre o analista",
    subtitle: "A Benndorf Research",
    col1: [
      "A Benndorf nasceu em 2015 com o objetivo de trazer informações e orientações para que o investidor possa gerir seus recursos de forma sólida e transparente, baseado em fundamentos.",

      "A partir do desenvolvimento de produtos, como são os nossos relatórios, assessoria e o suporte educacional percebemos que seria fundamental que o nosso negócio fosse além de uma casa de Research.",
    ],
    col2: [
      "Queremos facilitar e pavimentar a boa gestão dos investimentos dos nossos clientes! Por isso, desenvolvemos alguns conceitos de robôs baseados em anos de estudos, experiência e milhares de testes positivos.",
    ],
  },
  plans: {
    title: "Planos",
    subtitle:
      "Conheça os planos da Benndorf e veja qual se adequa melhor ao seu perfil.",
  },
  strategies: {
    title: "Estratégias Benndorf",
    heading:
      "O melhor da experiência do nosso analista, agora de forma automatizada.",
    // subtitle: "Estratégias prontas, desenvolvidas por profissionais. Comece agora mesmo com apenas alguns cliques.",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
